import { Button, Snackbar } from "@mui/material";

import logger from "~/helpers/logger";

import { useRegisterSW } from "virtual:pwa-register/react";

const SW_CHECK_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Surfaces the "new version available" prompt for the custom service worker. With
 * `registerType: "prompt"` the SW waits to activate until the user accepts, so a field worker is
 * never reloaded mid-task. Periodic update checks only run while online.
 */
const ReloadPrompt = () => {
	const {
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker
	} = useRegisterSW({
		onRegistered(registration) {
			if (registration) {
				setInterval(() => {
					if (!navigator.onLine) return;
					registration.update().catch(() => {});
				}, SW_CHECK_INTERVAL_MS);
			}
		},
		onRegisterError(error) {
			logger.error("SW registration error", error);
		}
	});

	return (
		<Snackbar
			open={needRefresh}
			message="A new version is available."
			action={
				<>
					<Button color="primary" size="small" onClick={() => updateServiceWorker(true)}>
						Reload
					</Button>
					<Button color="inherit" size="small" onClick={() => setNeedRefresh(false)}>
						Later
					</Button>
				</>
			}
		/>
	);
};

export default ReloadPrompt;
